import React from 'react'
import styled from 'styled-components'
import { Link } from '@raysync/common/components'
import { Media } from '@raysync/common/theme'
import intl from 'react-intl-universal'
export const CategoriesContainer = styled.div`
  margin-bottom: 28px;
  max-width: 900px;
  ${Media.phone`
    margin-bottom: .5rem;
    display: flex;
    flex-wrap: wrap;
  `}
`
export const CategoryItem = styled.span`
  display: inline-block;
  font-size: 14px;
  line-height: 36px;
  padding: 0 12px;
  border-radius: 6px;
  color: ${p => (p.isActived ? p.theme.color.secondary : p.theme.color.text)};
  background: ${p => (p.isActived ? '#FFEAE3' : '#F3F4F6')};
  margin-right: 12px;
  margin-bottom: 12px;
  ${Media.phone`
    font-size: .24rem;
    padding: 0 .2rem;
    margin: 0 .1rem .1rem .1rem;
  `}
  ${p => p.theme.Hack.mobileForeign`
    padding: 0 .12rem;
  `}
`

class Categories extends React.PureComponent {
  render() {
    const { data, location, isBlog } = this.props
    const isInNewsAll = /^.*\/news(\/page-\d)?$/.test(location.pathname.replace(/\/$/, ''))
    return (
      <CategoriesContainer>
        <Link to={`/${isBlog ? 'blog' : 'news'}/`}>
          <CategoryItem isActived={isInNewsAll}>{intl.get('news.all')}</CategoryItem>
        </Link>
        {data.map(({ name, slug }) => {
          return (
            <Link to={`/${isBlog ? 'blog' : 'news'}/category-${slug}`} key={slug}>
              <CategoryItem
                isActived={new RegExp(`/${isBlog ? 'blog' : 'news'}/category-${slug}`).test(location.pathname)}
              >
                {name}
              </CategoryItem>
            </Link>
          )
        })}
      </CategoriesContainer>
    )
  }
}
export default Categories
